import { isNewCatalogUser } from '../../utils/utils';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import { Redirect, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const NewUserLanding = () => {
  const location = useLocation();
  if (location.pathname !== '/' || !isNewCatalogUser(location.search)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: WIZARD_URL_FRAGMENT
    })
  });
};
export default NewUserLanding;